import { CanDeactivateFn } from '@angular/router';

import type { PhotoStationComponent } from './photo-station.component';

/**
 * Asks before the photo station's view is left with unsaved form input
 * (RIEG-274). Never asks after "Zurück zur Liste", which saves before it
 * navigates.
 */
export const photoStationLeaveGuard: CanDeactivateFn<PhotoStationComponent> = (
  component
) => component.confirmLeave();
